function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import PropTypes from 'prop-types';
import { Dropdown } from "../Autocomplete";
import { formatDate } from '@atheneum/api/dist/lib';
import { expertApi } from '@atheneum/api';

class Compliance extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "buildErrorGrowlProps", type => {
      return {
        title: 'Error!',
        message: `${type} is required.`,
        type: 'error',
        autoClose: true
      };
    });

    _defineProperty(this, "sendCompliance", async compliance => {
      const {
        complianceStore,
        expertStore,
        expert,
        callback,
        referrer
      } = this.props;
      const {
        growlStore
      } = expertStore;
      let complianceReferrer = referrer;
      let complianceExpert = expert;

      if (!Number(expert.id)) {
        await expertStore.get(expert.id);
        const expertProps = toJS(expertStore.expert);

        if (!expertProps.email) {
          growlStore.addNotification(this.buildErrorGrowlProps('Email'));
          return false;
        } else if (!expertProps.experiences.length) {
          growlStore.addNotification(this.buildErrorGrowlProps('Experience'));
          return false;
        } else if (!expertProps.languages.length) {
          growlStore.addNotification(this.buildErrorGrowlProps('Language'));
          return false;
        } else if (!expertProps.title) {
          growlStore.addNotification(this.buildErrorGrowlProps('Title'));
          return false;
        } else {
          const createdExpert = await expertApi.create(expertProps);
          complianceExpert = { ...createdExpert,
            userId: createdExpert.id
          };
          complianceReferrer = `expert-search/expert/${createdExpert.id}`;
        }
      }

      await complianceStore.sendCompliance(complianceExpert, { ...compliance,
        referrer: complianceReferrer || null
      });

      if (expert.id && !Number(expert.id)) {
        this.props.history.replace(`${this.props.history.location.pathname.includes('expert-search') ? '/expert-search' : ''}/expert/${complianceExpert.id}`);
      }

      callback();
    });

    _defineProperty(this, "renderLabel", hasNewCompliance => {
      const {
        expert
      } = this.props;

      if (expert.complianceRequestedBy && !hasNewCompliance) {
        if (expert.complianceSigned) {
          return 'NEW compliance requested';
        } else {
          return 'Compliance requested';
        }
      }

      if (expert.complianceSigned && !hasNewCompliance) {
        return 'NEW compliance missing';
      } else {
        return 'Compliance missing';
      }
    });

    _defineProperty(this, "renderActionLabel", () => {
      if (this.props.expert.complianceRequestedBy) {
        return 'Click to resend';
      }

      return 'Send compliance request';
    });

    _defineProperty(this, "renderLabelClass", hasNewCompliance => {
      const {
        expert
      } = this.props;
      if (expert.complianceSigned && hasNewCompliance) return 'default-label';
      return 'danger-label';
    });
  }

  hasNewCompliance(expert) {
    const {
      staticData
    } = this.props;
    const {
      complianceSigned,
      complianceDate
    } = expert;
    return complianceSigned && new Date(complianceDate) >= new Date(staticData.complianceValidDate);
  }

  render() {
    const {
      expert,
      complianceStore,
      className
    } = this.props;
    const hasNewCompliance = this.hasNewCompliance(expert);

    if (hasNewCompliance) {
      return /*#__PURE__*/React.createElement("span", {
        className: "code-label"
      }, "Compliance in place since ", formatDate(expert.complianceDate));
    }

    const classes = className ? `compliance-wrapper ${className}` : 'compliance-wrapper';
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: classes
    }, /*#__PURE__*/React.createElement("span", {
      className: this.renderLabelClass(hasNewCompliance)
    }, this.renderLabel(hasNewCompliance)), /*#__PURE__*/React.createElement("div", {
      className: "compliance-box"
    }, /*#__PURE__*/React.createElement("span", {
      className: "action-label"
    }, /*#__PURE__*/React.createElement(Dropdown, {
      containerClassName: "compliance__container",
      dropdownClassName: "compliance__dropdown",
      placeholder: this.renderActionLabel(),
      options: complianceStore.complianceLanguages,
      itemToString: renderComplianceAction,
      onChange: this.sendCompliance
    })))));
  }

}

_defineProperty(Compliance, "propTypes", {
  staticData: PropTypes.object,
  complianceStore: PropTypes.object,
  commentStore: PropTypes.object,
  expertStore: PropTypes.object,
  modalStore: PropTypes.object,
  expert: PropTypes.object.isRequired,
  className: PropTypes.string,
  allowComplianceUpdate: PropTypes.bool,
  callback: PropTypes.func,
  referrer: PropTypes.string
});

export default inject('staticData', 'complianceStore', 'modalStore', 'expertStore')(observer(Compliance));

function renderComplianceAction(item) {
  const complianceLanguageText = item && item.language && item.language.name;
  return /*#__PURE__*/React.createElement("div", {
    className: "compliance-box__list-item"
  }, "Send compliance in ", /*#__PURE__*/React.createElement("b", null, complianceLanguageText));
}